module.exports = __webpack_public_path__ + "static/media/sample_check.bc7e9372.jpg";